// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.container-label-input-padrao {
    display: flex;
    align-items: center;
    width: 100%;
    min-width: max-content;
}

.principais-input-padrao {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 0.3rem;
    margin-bottom: 0.2rem;
    position: relative;
}

.container-label-input-padrao svg {
    font-size: 1.4rem;
    color: var(--azul-dixi);
}

.container-label-input-padrao label {
    color: var(--cinza-label-input-padrao);
    font-size: .9rem;
    font-weight: bold;
}

.container-obrigatorio-input-padrao {
    position: absolute;
    right: -6px;
    top: -2px;
}

.input-padrao-estilo {
    height: 2.4rem;
    width: 100%;
    border: none;
    background-color: var(--cinza-fundo-input-padrao);
    outline: none;
    border-radius: 5px;
    padding: .8rem 1.3rem;
    font-size: .9rem;
    color: var(--text-color);
    min-width: max-content;
}

.input-padrao-estilo:hover, .input-padrao-estilo:focus {
    outline: 2px solid var(--azul-dixi);
}

.input-padrao-estilo::placeholder {
    color: var(--cinza-placeholder);
}

.erro-invalido {
    outline: 2px solid var(--error-color);
    border-radius: 5px;
}

.erro-invalido:hover {
    outline: 2px solid var(--error-color);
}

.erro-invalido.input-padrao-estilo:focus {
    outline: 2px solid var(--error-color);
}`, "",{"version":3,"sources":["webpack://./src/components/InputPadrao/InputPadrao.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,mBAAmB;IACnB,WAAW;IACX,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,qBAAqB;IACrB,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;IACjB,uBAAuB;AAC3B;;AAEA;IACI,sCAAsC;IACtC,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,SAAS;AACb;;AAEA;IACI,cAAc;IACd,WAAW;IACX,YAAY;IACZ,iDAAiD;IACjD,aAAa;IACb,kBAAkB;IAClB,qBAAqB;IACrB,gBAAgB;IAChB,wBAAwB;IACxB,sBAAsB;AAC1B;;AAEA;IACI,mCAAmC;AACvC;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,qCAAqC;IACrC,kBAAkB;AACtB;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,qCAAqC;AACzC","sourcesContent":[".container-label-input-padrao {\n    display: flex;\n    align-items: center;\n    width: 100%;\n    min-width: max-content;\n}\n\n.principais-input-padrao {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    gap: 0.3rem;\n    margin-bottom: 0.2rem;\n    position: relative;\n}\n\n.container-label-input-padrao svg {\n    font-size: 1.4rem;\n    color: var(--azul-dixi);\n}\n\n.container-label-input-padrao label {\n    color: var(--cinza-label-input-padrao);\n    font-size: .9rem;\n    font-weight: bold;\n}\n\n.container-obrigatorio-input-padrao {\n    position: absolute;\n    right: -6px;\n    top: -2px;\n}\n\n.input-padrao-estilo {\n    height: 2.4rem;\n    width: 100%;\n    border: none;\n    background-color: var(--cinza-fundo-input-padrao);\n    outline: none;\n    border-radius: 5px;\n    padding: .8rem 1.3rem;\n    font-size: .9rem;\n    color: var(--text-color);\n    min-width: max-content;\n}\n\n.input-padrao-estilo:hover, .input-padrao-estilo:focus {\n    outline: 2px solid var(--azul-dixi);\n}\n\n.input-padrao-estilo::placeholder {\n    color: var(--cinza-placeholder);\n}\n\n.erro-invalido {\n    outline: 2px solid var(--error-color);\n    border-radius: 5px;\n}\n\n.erro-invalido:hover {\n    outline: 2px solid var(--error-color);\n}\n\n.erro-invalido.input-padrao-estilo:focus {\n    outline: 2px solid var(--error-color);\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
